import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminVenues = lazy(() => import("@/pages/admin/AdminVenues"));

export const Route = createFileRoute("/admin/venues")({
  component: AdminVenues,
});
